export const SERVICE = {
  LOGO_DE_COEUR: 'LOGO_DE_COEUR',
  REPLACEMENT_CAR: 'REPLACEMENT_CAR',
  WINTER_TYRES: 'WINTER_TYRES',
  TYRES: 'TYRES',
}
